import toastr from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';

import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import {
  SingleWorkspaceRecommendationsResponse,
  WorkspaceRecommendationAttributes,
} from 'types/Workspace';

type mutationRecommendationVariables =
  Partial<WorkspaceRecommendationAttributes> & { id: string };

export function useUpdateWorkSpaceRecommendation() {
  const queryClient = useQueryClient();

  const updateWorkSpaceRecommendation = ({
    id: workspaceRecommendationID,
    ...rest
  }: mutationRecommendationVariables) => {
    if (!workspaceRecommendationID) {
      return Promise.reject('workspaceRecommendation ID not found');
    }

    const body = {
      data: {
        id: workspaceRecommendationID,
        type: SPARK_RESOURCE_TYPES.WORKSPACE_RECOMMENDATIONS,
        attributes: rest,
      },
    };
    const url = generateURL(
      SPARK_RESOURCE_TYPES.WORKSPACE_RECOMMENDATIONS,
      [],
      workspaceRecommendationID
    );
    return fetchWrapper<SingleWorkspaceRecommendationsResponse>({
      url: url,
      method: 'PATCH',
      body: body,
    });
  };

  return useMutation(
    'UpdateWorkSpaceRecommendation',
    updateWorkSpaceRecommendation,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['workspaceRecommendations']);

        toastr.success('Recommendations updated successfully');
      },
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(`Failed to update recommendation: ${error.message}`);
        }
      },
    }
  );
}
